<template>
  <div>
    <div v-if="start" class="bg" :style="background(currentQuestion.background)">
      <!-- QUESTIONS -->
      <template v-if="currentQuestion">
        <top-navigation v-show="!answered" :show-back="false" :in-game="true"></top-navigation>
        <div class="container-fluid pt-2">
        <template v-if="answered">
          <div class="row align-items-center question-wrapper">
            <div class="col-3"></div>
            <div class="col-6">
              <div class="answer-container h-100 d-table">
                <div class="d-table-cell align-middle">
                  <h1>{{ currentQuestion.trueFalse === userAnswer ? 'That\'s right!' : 'Oops, wrong answer!' }}</h1>
                  {{ currentQuestion.answer}}
                </div>
              </div>
              <div class="next-button">
                <button class="btn ng-default-btn btn-primary next-btn" @click="newQuestion()">NEXT</button>
              </div>
            </div>
            <div class="col-3"></div>
          </div>
        </template>
        <template v-else>
          <div class="row align-items-center h-75 question-wrapper">
            <div class="col-3 col-xs-2 text-center" @click="answer(false)">
              <img src="../../assets/img/false.png"/>
            </div>
            <div class="col-6 col-xs-8">
              <div class="question-container h-100 d-table">
                <div class="d-table-cell align-middle">
                  {{ currentQuestion.question}}
                </div>
              </div>
            </div>
            <div class="col-3 col-xs-2 text-center" @click="answer(true)">
              <img src="../../assets/img/true.png"/>
            </div>
          </div>
        </template>
          <div class="fixed-bottom">
            <div class="row">
              <div class="col-8 shoe-progress">
                <img :style="{ left: (totalAnswers / questions.length)  * 100 + '%' }" class="shoe-progress-img" :src="avatar.avatarShoes.avatarShoeImage"/>
              </div>
              <div class="col-2 text-center score">
                <h1>{{ gameScore | numberWithCommas }}</h1>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <game-description @start="start = true" v-else title="TRUE OR FALSE" description="Put your animal knowledge to the test in our quick-fire True or False quiz!"></game-description>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import GameDescription from '../../components/GameDescription'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import shuffle from 'shuffle-array'

export default {
  name: 'TrueOrFalse',
  components: {
    TopNavigation,
    GameDescription
  },
  data () {
    return {
      start: false,
      answered: false,
      userAnswer: false,
      gameScore: 0,
      totalAnswers: 0,
      answeredQuestions: []
    }
  },
  methods: {
    ...mapMutations(['setQuestionAnswered', 'addTotalTrueAnswers', 'setLastGameScore']),
    ...mapActions(['cardsUnlock', 'addToScore']),
    answer (value) {
      this.totalAnswers++
      this.answered = true
      this.userAnswer = value
      if (value === this.currentQuestion.trueFalse) {
        this.gameScore += 450
        this.addToScore(450)
        this.addTotalTrueAnswers()
        if (this.totalTrueAnswers >= 10) {
          this.gameScore += 500
          this.addToScore(500)
        }
      }
    },
    newQuestion () {
      this.answered = false
      this.userAnswer = false
      this.answeredQuestions.push(this.currentQuestion.ID)
      if (this.totalAnswers === 10) {
        this.setLastGameScore(this.gameScore)
        this.$router.push({ name: 'GameScore' })
      }
    },
    endGame () {
      if (this.gameScore >= 2700) {
        this.cardsUnlock('trueOrFalse')
      }
    },
    background (url) {
      return { 'background-image': 'url(' + url + ')' }
    }
  },
  computed: {
    ...mapGetters(['score', 'questions', 'totalTrueAnswers', 'avatar']),
    currentQuestion () {
      const question = shuffle(this.questions.filter(question => !this.answeredQuestions.includes(question.ID)).map(question => {
        return {
          question: question.meta.question,
          answer: question.meta.answer,
          trueFalse: (question.meta.true_false === 'true'),
          ID: question.ID,
          background: question.meta.background
        }
      }))
      if (question.length) {
        return question[0]
      } else {
        return false
      }
    }
  },
  watch: {
    totalAnswers (total) {
      if (total === 10) {
        this.endGame()
      }
    }
  },
  filters: {
    numberWithCommas (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/true-or-false-bg.jpg");
    background-size: cover;
    background-position: center;
  }

  .question-container, .answer-container {
    width: 100%;
    border: 10px solid #ffbf00;
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    font-family: "Geograph-Bold";
    font-size: 3vw;
    padding: 10pt;
    text-align: center;
    min-height: 50vh;
  }

  .answer-container {
    padding-bottom: 5vh;
  }

  .question-wrapper {
    height: 75vh;
  }

  .question .question-wrapper img {
    max-width: 100%;
  }

  h1 {
    font-size: 4vw;
    color: #ffcc00;
    font-family: "Geograph-Black";
  }

  .score h1 {
    font-size: 4vw;
  }

  .question-wrapper img {
    width: 80%;
  }

  .shoe-progress {
    width: 80%;
    background-image: url("../../assets/img/progress.png");
    background-repeat: repeat-x;
    height: 12vh;
    background-size: 30%;
    background-position: left center;
    margin-left: auto;
    margin-right: auto;
  }

  .shoe-progress-img {
    position: absolute;
    bottom: 20%;
    max-width: 180px;
    margin-left: -1vw;
  }

  .result-bottom {
    position: absolute;
    bottom: 1vh;
    width: 100%;
  }

  .next-button {
    text-align: center;
    margin-top: -2.8vw;
  }

  @media (max-height: 375px) {
    .shoe-progress-img {
      width: 80px;
    }
  }
</style>
